if (!customElements.get('kh-ring-size-menu')) {
  customElements.define('kh-ring-size-menu', class extends HTMLElement {
    connectedCallback() {
      if (this.button) return;
      this.select = this.querySelector('select');
      if (!this.select) return;
      this.options = Array.from(this.select.options).filter(option => !option.disabled);
      this.button = document.createElement('button');
      this.button.type = 'button';
      this.button.id = this.select.id + '-button';
      this.button.className = 'kh-size-menu__button';
      this.button.setAttribute('role', 'combobox');
      this.button.setAttribute('aria-haspopup', 'listbox');
      this.button.setAttribute('aria-expanded', 'false');
      this.button.setAttribute('aria-controls', this.select.id + '-list');
      this.button.setAttribute('aria-required', String(this.select.required));
      if (this.select.hasAttribute('aria-describedby')) this.button.setAttribute('aria-describedby', this.select.getAttribute('aria-describedby'));
      const label = this.closest('.product-form__input').querySelector('label');
      label.id = this.select.id + '-label';
      label.htmlFor = this.button.id;
      this.button.setAttribute('aria-labelledby', label.id + ' ' + this.button.id + '-value');
      this.valueLabel = document.createElement('span');
      this.valueLabel.id = this.button.id + '-value';
      this.button.append(this.valueLabel);
      const caret = this.querySelector('.svg-wrapper');
      if (caret) this.button.append(caret.cloneNode(true));
      this.list = document.createElement('ul');
      this.list.id = this.select.id + '-list';
      this.list.className = 'kh-size-menu__list';
      this.list.setAttribute('role', 'listbox');
      this.list.setAttribute('aria-labelledby', label.id);
      this.list.hidden = true;
      this.items = this.options.map((option, index) => {
        const item = document.createElement('li');
        item.id = this.select.id + '-size-' + index;
        item.setAttribute('role', 'option');
        item.className = 'kh-size-menu__option';
        if ((!this.hasAttribute('data-diamond-menu') && index === this.options.length - 2) || (this.hasAttribute('data-diamond-menu') && /concierge|enquire/i.test(option.textContent))) item.classList.add('kh-size-menu__option--advice');
        item.textContent = option.textContent;
        item.addEventListener('pointerdown', event => event.preventDefault());
        item.addEventListener('click', () => this.choose(index));
        this.list.append(item);
        return item;
      });
      this.append(this.button, this.list);
      this.select.tabIndex = -1;
      this.select.setAttribute('aria-hidden', 'true');
      this.classList.add('kh-size-menu--ready');
      this.sync();
      this.select.addEventListener('change', () => this.sync());
      this.select.addEventListener('focus', () => this.button.focus());
      this.select.addEventListener('invalid', event => {
        event.preventDefault();
        this.button.setAttribute('aria-invalid', 'true');
        this.button.focus();
        this.open();
      });
      this.button.addEventListener('click', () => this.list.hidden ? this.open() : this.close());
      this.button.addEventListener('keydown', event => this.onKey(event));
      this.outside = event => { if (!this.contains(event.target)) this.close(); };
      document.addEventListener('pointerdown', this.outside);
      this.addEventListener('focusout', event => { if (!this.contains(event.relatedTarget)) this.close(); });
    }
    disconnectedCallback() { document.removeEventListener('pointerdown', this.outside); }
    sync() {
      this.valueLabel.textContent = this.select.selectedOptions[0].textContent;
      this.items.forEach((item, index) => item.setAttribute('aria-selected', String(this.options[index].value === this.select.value)));
      if (this.select.value) this.button.removeAttribute('aria-invalid');
    }
    open() {
      this.list.hidden = false;
      const bounds = this.button.getBoundingClientRect();
      const roomBelow = window.innerHeight - bounds.bottom;
      this.classList.toggle('kh-size-menu--above', roomBelow < this.list.offsetHeight + 12 && bounds.top > roomBelow);
      this.button.setAttribute('aria-expanded', 'true');
      this.active = Math.max(0, this.options.findIndex(option => option.value === this.select.value));
      this.highlight();
    }
    close() {
      if (!this.button) return;
      this.list.hidden = true;
      this.button.setAttribute('aria-expanded', 'false');
      this.button.removeAttribute('aria-activedescendant');
    }
    highlight() {
      this.items.forEach((item, index) => item.classList.toggle('is-active', index === this.active));
      this.button.setAttribute('aria-activedescendant', this.items[this.active].id);
      this.items[this.active].scrollIntoView({ block: 'nearest' });
    }
    choose(index) {
      if (this.dataset.conciergeUrl && this.options[index].value === 'private-concierge') {
        window.location.assign(this.dataset.conciergeUrl);
        return;
      }
      this.select.value = this.options[index].value;
      this.select.dispatchEvent(new Event('input', { bubbles: true }));
      this.select.dispatchEvent(new Event('change', { bubbles: true }));
      this.sync();
      this.close();
      this.button.focus();
    }
    onKey(event) {
      if (event.key === 'Escape' || event.key === 'Tab') { this.close(); return; }
      if (['ArrowDown', 'ArrowUp', 'Home', 'End', 'Enter', ' '].includes(event.key)) {
        event.preventDefault();
        if (this.list.hidden) { this.open(); return; }
        if (event.key === 'Enter' || event.key === ' ') { this.choose(this.active); return; }
        if (event.key === 'Home') this.active = 0;
        else if (event.key === 'End') this.active = this.items.length - 1;
        else this.active = Math.max(0, Math.min(this.items.length - 1, this.active + (event.key === 'ArrowDown' ? 1 : -1)));
        this.highlight();
      } else if (event.key.length === 1 && !event.ctrlKey && !event.metaKey && !event.altKey) {
        const index = this.options.findIndex(option => option.textContent.toLowerCase().startsWith(event.key.toLowerCase()));
        if (index >= 0) { event.preventDefault(); if (this.list.hidden) this.open(); this.active = index; this.highlight(); }
      }
    }
  });
}


